// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import { CartContext } from "@insite/client-framework/Components/CartContext";
import { updateCart, updateCartWithResult } from "@insite/client-framework/Services/CartService";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { SignatureData, SignatureModel } from "@store/Framework/Store/Bunzl/Pages/Signature/SignatureReducer";
import { useCurrentCart } from "@toolkit/Framework/Store/Data/Carts/CartsHooks";
import { useContext, useMemo } from "react";

const useSignatureData = () => {
    const { value: orderContext } = useContext(OrderStateContext);
    const cartContextCart = useContext(CartContext);
    const currentCart = useCurrentCart();
    const cart = cartContextCart ?? currentCart;
    const dispatch = useAppDispatch();

    const setSignature = async (signatureData: SignatureData | undefined) => {
        if (!cart) {
            return;
        }
        const updatedData = signatureData
            ? {
                  signatureName: signatureData.customerName,
                  signatureBase64: signatureData.customerSignature,
                  signatureTimestamp: signatureData.timestamp,
                  signatureEmail: signatureData.customerEmail ?? "",
              }
            : {
                  signatureName: "",
                  signatureBase64: "",
                  signatureTimestamp: "",
                  signatureEmail: "",
              };

        await updateCart({
            cart: {
                ...cart,
                properties: {
                    ...cart.properties,
                    ...updatedData,
                },
            },
        });
        dispatch(loadCart({ cartId: cart.id, shouldLoadFullCart: true }));
    };
    const signatureStateToUse = orderContext || cart;
    const signatureData: SignatureModel = useMemo(
        () => ({
            customerName: signatureStateToUse?.properties?.signatureName ?? "",
            customerSignature: signatureStateToUse?.properties?.signatureBase64 ?? "",
            timestamp: signatureStateToUse?.properties?.signatureTimestamp ?? "",
            customerEmail: signatureStateToUse?.properties?.signatureEmail ?? "",
            orderNumber: signatureStateToUse?.erpOrderNumber ?? "",
        }),
        [signatureStateToUse],
    );

    return { signatureData, setSignature };
};

export default useSignatureData;
